(ns app.front.ui.tab-panel
  "A component where only one tab is visible at a time"
  (:require [app.front.ui.content-switcher :as ui-cs]
            [core.front.event :refer [<sub >evt]]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))


(rf/reg-sub ::selected-config-tab
  (fn [db [_ tabs-id]]
    (get-in db [::selected-config-tab tabs-id])))

(rf/reg-event-db ::select-config-tab
  (fn [db [_ tabs-id tab-key]]
    (assoc-in db [::selected-config-tab tabs-id] tab-key)))


(defn tab-panel
  "A tab-like content switcher with the selected content shown below it
  Opts:
  id                string or keyword, used for storing the selected tab in re-frame
  tabs              seq of maps:
                    {:key     (string or keyword, the unique id of the tab)
                     :content (hiccup, content to be displayed when this tab is selected)
                     :hidden? (bool, truthy if the tab should not be included)}
  key->str          fn, takes the tab's key and turns it into a string for the tab label
  class             optional string, CSS class used for the container div
  switcher-class    optional string, CSS class used for the content switcher
  tab-class         optional string, CSS class for the tab contents container"
  [{:keys [id tabs key->str class switcher-class tab-class]}]
  (let [selected-tab-key (or (<sub [::selected-config-tab id])
                             (->> tabs (remove :hidden?) first :key))
        selected-tab     (p/find-first tabs {:key selected-tab-key})]
    [:div
     {:class class}
     [ui-cs/content-switcher
      {:items     (->> tabs (remove :hidden?) (map :key))
       :val->str  key->str
       :current   selected-tab-key
       :on-change #(>evt [::select-config-tab id %])
       :class     (str switcher-class)}]
     [:div.w-full.border-t.border-solid.border-ui-violet
      {:class tab-class}
      (when-not (:hidden? selected-tab)
        (:content selected-tab))]]))
